import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=fb5b3a9a&scoped=true&"
import script from "./StatusBadge.vue?vue&type=script&lang=ts&"
export * from "./StatusBadge.vue?vue&type=script&lang=ts&"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=fb5b3a9a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5b3a9a",
  null
  
)

export default component.exports